export default function sortAscending(a, b, columnName) {
  const colA = a[columnName];
  const colB = b[columnName];
  if (colA < colB) {
    return 1;
  }
  if (colA > colB) {
    return -1;
  }
  return 0;
}

export function sortDescending(a, b, columnName) {
  const colA = a[columnName];
  const colB = b[columnName];
  if (colA < colB) {
    return -1;
  }
  if (colA > colB) {
    return 1;
  }
  return 0;
}
